// following ISO 639 standard language codes datasheet
export enum SupportedLanguages {
  ENGLISH = 'en',
  FRENCH = 'fr',
  GERMAN = 'de',
  RUSSIAN = 'ru',
  SPANISH = 'es',
  TURKISH = 'tr',
  ARABIC = 'ar',
  CHINESE = 'zh',
  TAMIL = 'ta',
  VIETNAMESE = 'vi',
  KAZAKH = 'kk',
  ITALIAN = 'it',
  DUTCH = 'nl',
  HEBREW = 'he',
  KOREAN = 'ko',
  PORTUGUESE = 'pt',
  THAI = 'th',
  UKRAINIAN = 'uk',
  POLISH = 'pl',
  ROMANIAN = 'ro',
  HINDI = 'hi',
  TRANSLATIONS = 'xx',
}

// following standard ISO 3166 and ISO 639 locale datasheets
export enum SupportedLocales {
  ENGLISH = 'en-US',
  FRENCH = 'fr-FR',
  GERMAN = 'de-DE',
  RUSSIAN = 'ru-RU',
  SPANISH = 'es-ES',
  TURKISH = 'tr-TR',
  ARABIC = 'ar-AE',
  CHINESE = 'zh-CN',
  TAMIL = 'ta-IN',
  VIETNAMESE = 'vi-VN',
  KAZAKH = 'kk-KZ',
  ITALIAN = 'it-IT',
  DUTCH = 'nl-NL',
  HEBREW = 'he-IL',
  KOREAN = 'ko-KR',
  PORTUGUESE = 'pt-PT',
  THAI = 'th-TH',
  UKRAINIAN = 'uk-UA',
  POLISH = 'pl-PL',
  ROMANIAN = 'ro-RO',
  HINDI = 'hi-IN',
  TRANSLATIONS = 'xx-XX',
}

export const ENABLED_LANGUAGES = [
  SupportedLanguages.ENGLISH,
  SupportedLanguages.FRENCH,
  SupportedLanguages.GERMAN,
  SupportedLanguages.RUSSIAN,
  SupportedLanguages.SPANISH,
  SupportedLanguages.TURKISH,
  SupportedLanguages.ARABIC,
  SupportedLanguages.CHINESE,
  SupportedLanguages.TAMIL,
  SupportedLanguages.VIETNAMESE,
  SupportedLanguages.KAZAKH,
  SupportedLanguages.ITALIAN,
  SupportedLanguages.DUTCH,
  SupportedLanguages.HEBREW,
  SupportedLanguages.KOREAN,
  SupportedLanguages.PORTUGUESE,
  SupportedLanguages.THAI,
  SupportedLanguages.UKRAINIAN,
  SupportedLanguages.POLISH,
  SupportedLanguages.ROMANIAN,
  SupportedLanguages.HINDI,
  SupportedLanguages.TRANSLATIONS,
];

/**
 * Supported brand for name and icon
 * When adding a new brand remember to update the linked file
 * @link ~~/helpers/brand.helper.ts
 */
export type SupportedBrands =
  | 'AAI'
  | 'ALI'
  | 'FAI'
  | 'HYD'
  | 'RIX'
  | 'SLS'
  | 'SO'
  | 'SWI'
  | 'MOD';

// @see https://jira.kaliop.net/browse/ACCORDAI-81
export const CountryToCurrencyMapping = {
  TR: 'TRY',
  RU: 'RUB',
  AE: 'AED',
  GB: 'GBP',
  KZ: 'KZT',
  UA: 'UAH',
  DE: 'EUR',
  US: 'USD',
  AZ: 'AZN',
  EG: 'USD',
  RO: 'EUR',
  SA: 'SAR',
  CH: 'CHF',
  IR: 'IRR',
  FR: 'EUR',
  NL: 'EUR',
  BE: 'EUR',
  IT: 'EUR',
  ES: 'EUR',
} as const;

export const DEFAULT_LANGUAGE = SupportedLanguages.ENGLISH;

export const DEFAULT_LOCALE = SupportedLocales.ENGLISH;

export const DEFAULT_CURRENCY = CountryToCurrencyMapping.US;

export const DEFAULT_BRAND: SupportedBrands = 'ALI';

export const DATE_PICKER_MAX_RANGE = 30;

export const SESSION_STORAGE_KEYS = {
  BASKET_AUTH_CREATION: 'aic_auth_basket_status',
  BASKET_ID: 'booking::basketID',
  BENEFICIARY: 'booking::beneficiary',
  BOOKING_URL: 'booking::URL',
  SPECIAL_REQUEST: 'booking::specialRequest',
  TRIP_TYPE: 'booking::tripType',
  POST_BOOKING_PAYLOAD: 'booking::postBookingPayload',
  EXTERNAL_DATA_SESSION_KEY: 'feat.external-data',
  PAYMENT_METHOD: 'booking::paymentMethod',
};
